import { normalizeUpdateTasks } from '@griply/utils';
import { useMutation } from '@tanstack/react-query';
import { updateTask } from 'shared/services/backend-api';
import { UpdateTask } from 'shared/types/task';

export const useUpdateTaskMutation = () =>
  useMutation({
    mutationFn: async (task: UpdateTask) =>
      updateTask(normalizeUpdateTasks([task])[0]),
  });
